import request from '@/utils/request'

// 监测策略列表
export function getPauseStrategyList(params = {}) {
  return request({
    url: '/ad_copy/pause_strategy/list',
    method: 'get',
    params
  })
}

// 获取可创建的策略条件
export function getPauseStrategyConditions() {
  return request({
    url: '/ad_copy/pause_strategy/get_create_where',
    method: 'get'
  })
}

// 创建监测策略
export function createPauseStrategy(data) {
  return request({
    url: '/ad_copy/pause_strategy/create',
    method: 'post',
    data
  })
}

// 更新监测策略
export function updatePauseStrategy(data) {
  return request({
    url: '/ad_copy/pause_strategy/update',
    method: 'post',
    data
  })
}

// 更新策略状态
export function updatePauseStrategyStatus(data) {
  return request({
    url: '/ad_copy/pause_strategy/update_status',
    method: 'post',
    data
  })
}

// 删除监测策略
export function deletePauseStrategy(data) {
  return request({
    url: '/ad_copy/pause_strategy/del',
    method: 'post',
    data
  })
}

// 策略执行记录
export function getPauseStrategyLogs(params = {}) {
  return request({
    url: '/ad_copy/pause_strategy/strategy_log',
    method: 'get',
    params
  })
}
